import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const StreakFreezeIcon = ({ classObject }) => {
    return React.createElement("img", { src: "/assets/images/icons/streak_freeze.svg", className: css(styles.icon, classObject) });
};
const styles = StyleSheet.create({
    icon: {
        width: 16,
        height: 16,
    },
});
